import { render, staticRenderFns } from "./ManualOrganization.vue?vue&type=template&id=5d0501a0&"
import script from "./ManualOrganization.vue?vue&type=script&lang=js&"
export * from "./ManualOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports